import { CheckIcon } from "lucide-react";

export function NumberRing({ digit, isSelected }: { digit: number; isSelected: boolean }) {
  const variantClasses = isSelected ? "border-2 border-[#14DBC0] bg-[#14DBC033]/20" : "bg-[#4F7A99]";

  return <span className={`${variantClasses} rounded-full text-center size-8 pt-1`}>{digit}</span>;
}

export function CheckCircle() {
  return <CheckIcon className="size-8 text-[#1A2934] bg-[#14DBC0] rounded-full p-1.5" />;
}
